export const SEASON_BADGES = ['season_champion', 'season_podium', 'season_top10', 'season_top100'];
export const DEFAULT_SEASON_WEEKS = 8;
export const DEFAULT_SEASON_PRIZES = [
    { fromRank: 1, toRank: 1, points: 50_000, badge: 'season_champion' },
    { fromRank: 2, toRank: 3, points: 25_000, badge: 'season_podium' },
    { fromRank: 4, toRank: 10, points: 10_000, badge: 'season_top10' },
    { fromRank: 11, toRank: 100, points: 2_500, badge: 'season_top100' },
];
/** Returns an error message, or null when the prize table is valid. */
export function validateSeasonPrizes(prizes) {
    if (!Array.isArray(prizes) || prizes.length > 20)
        return 'Keep up to 20 prize rows';
    const sorted = [...prizes].sort((a, b) => a.fromRank - b.fromRank);
    for (let i = 0; i < sorted.length; i++) {
        const p = sorted[i];
        const label = `Ranks ${p.fromRank}–${p.toRank}`;
        if (!(Number.isInteger(p.fromRank) && Number.isInteger(p.toRank) && p.fromRank >= 1 && p.toRank >= p.fromRank && p.toRank <= 100_000))
            return `${label}: ranks must be whole numbers, from 1, low to high`;
        if (!(Number.isInteger(p.points) && p.points >= 0 && p.points <= 10_000_000))
            return `${label}: points must be a whole number, 0 or more`;
        if (p.badge !== null && !SEASON_BADGES.includes(p.badge))
            return `${label}: unknown badge`;
        if (i > 0 && p.fromRank <= sorted[i - 1].toRank)
            return `${label}: overlaps ranks ${sorted[i - 1].fromRank}–${sorted[i - 1].toRank}`;
    }
    return null;
}
export const prizeFor = (prizes, rank) => prizes.find((p) => rank >= p.fromRank && rank <= p.toRank) ?? null;
const STATIC_BADGES = [
    { id: 'starter', name: 'Starter', text: 'Finished the starter journey', mark: 'ST' },
    { id: 'streak_4', name: 'Steady', text: '4-week mission streak', mark: '4W' },
    { id: 'streak_12', name: 'Committed', text: '12-week mission streak', mark: '12W' },
    { id: 'streak_26', name: 'Half-year', text: '26-week mission streak', mark: '26W' },
    { id: 'streak_52', name: 'Year-round', text: '52-week mission streak', mark: '52W' },
    { id: 'friends_5', name: 'Connector', text: '5 friends who joined and traded', mark: 'C' },
    { id: 'friends_25', name: 'Ambassador', text: '25 friends who joined and traded', mark: 'A' },
    { id: 'season_champion', name: 'Season champion', text: 'Finished a season in 1st place', mark: '1' },
    { id: 'season_podium', name: 'Podium', text: 'Finished a season in the top 3', mark: '3' },
    { id: 'season_top10', name: 'Top 10', text: 'Finished a season in the top 10', mark: '10' },
    { id: 'season_top100', name: 'Top 100', text: 'Finished a season in the top 100', mark: '100' },
];
/** Every badge a client can earn, with one per tier after the first. */
export function badgeCatalog(tiers) {
    const tierBadges = tiers.slice(1).map((t) => ({ id: `tier_${t.id}`, name: t.name, text: `Reached the ${t.name} tier`, mark: t.name[0] ?? '?' }));
    return [STATIC_BADGES[0], ...tierBadges, ...STATIC_BADGES.slice(1)];
}
/** Season badges outrank the rest when only a few fit next to a name. */
export const BADGE_ORDER = ['season_champion', 'season_podium', 'season_top10', 'season_top100', 'streak_52', 'streak_26', 'friends_25', 'streak_12', 'friends_5', 'streak_4', 'starter'];
//# sourceMappingURL=seasons.js.map